import { render, staticRenderFns } from "./jiugonggeForm.vue?vue&type=template&id=36f6f621&scoped=true&"
import script from "./jiugonggeForm.vue?vue&type=script&lang=js&"
export * from "./jiugonggeForm.vue?vue&type=script&lang=js&"
import style0 from "./jiugonggeForm.vue?vue&type=style&index=0&id=36f6f621&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6f621",
  null
  
)

export default component.exports